import buttonRadar from '../shared/button-radar.vue'
import back from '../shared/back.vue'
import ratingComponent from '../shared/rating.vue';


export default  {

  name: 'details',

  components: {

    ratingComponent,
    buttonRadar,
    back

  },


  data() {
    return {

      // Get the product comparison data
      data: this.$store.state.compare,

    }
  },


  mounted(){

    localStorage.setItem('play', true);

    let app = document.getElementById("app");
    app.style.backgroundImage = "";

  },

}




// WEBPACK FOOTER //
// ./src/components/compare/compare.component.js